import React, { useEffect, useMemo, useRef, useState } from 'react'
import { ImSpinner2 } from 'react-icons/im'
import { TooltipIcon } from './Tooltips/TooltipInfos';
import "../../styles/card.css"

export const Cards = (props) => {
    const { data, isLoading = false } = props;
    const cardRef = useRef(null);
    const [cardsPorLinha, setCardsPorLinha] = useState(1);


    useEffect(() => {
        if (!cardRef.current) return;

        const updateCardsPerRow = () => {
            const gridWidth = cardRef.current.offsetWidth;
            const firstCard = cardRef.current.querySelector(".kpi-card");
            const cardWidth = firstCard ? firstCard.offsetWidth : 150;

            setCardsPorLinha(Math.floor(gridWidth / cardWidth));
        };

        const resizeObserver = new ResizeObserver(updateCardsPerRow);
        resizeObserver.observe(cardRef.current);

        updateCardsPerRow();

        return () => resizeObserver.disconnect();
    }, []);


    const sobra = data.length % cardsPorLinha;
    const placeholders = sobra === 0 ? [] : Array(cardsPorLinha - sobra).fill(null);

    // ✅ Mapeamento de labels para tooltips
    const labelToTooltip = {
        "Veículos ativos": "DASHBOARD_CARDS_ACTIVE_VEHICLES",
        "Odômetro total": "DASHBOARD_CARDS_TOTAL_ODOMETER",
        "Km horário comercial": "DASHBOARD_CARDS_KM_BUSINESS_HOURS",
        "Km fora do horário comercial": "DASHBOARD_CARDS_KM_OUTSIDE_HOURS",
        "Tempo de uso": "DASHBOARD_CARDS_ENGINE_TIME",
        "Tempo ocioso": "DASHBOARD_CARDS_IDLE_TIME",
        "Tempo desligado": "DASHBOARD_CARDS_OFF_TIME",
        "Km acima do limite da via": "DASHBOARD_CARDS_SPEED_LIMIT_DISTANCE",
        "Km acima do limite da empresa": "DASHBOARD_CARDS_COMPANY_SPEED_LIMIT_DISTANCE",
        // English
        "Active vehicles": "DASHBOARD_CARDS_ACTIVE_VEHICLES",
        "Total odometer": "DASHBOARD_CARDS_TOTAL_ODOMETER",
        "Km business hours": "DASHBOARD_CARDS_KM_BUSINESS_HOURS",
        "Km outside business hours": "DASHBOARD_CARDS_KM_OUTSIDE_HOURS",
        "Usage time": "DASHBOARD_CARDS_ENGINE_TIME",
        "Idle time": "DASHBOARD_CARDS_IDLE_TIME",
        "Off time": "DASHBOARD_CARDS_OFF_TIME",
        "Km above road speed limit": "DASHBOARD_CARDS_SPEED_LIMIT_DISTANCE",
        "Km above company speed limit": "DASHBOARD_CARDS_COMPANY_SPEED_LIMIT_DISTANCE",
        // Español
        "Vehículos activos": "DASHBOARD_CARDS_ACTIVE_VEHICLES",
        "Odómetro total": "DASHBOARD_CARDS_TOTAL_ODOMETER",
        "Km horario comercial": "DASHBOARD_CARDS_KM_BUSINESS_HOURS",
        "Km fuera del horario comercial": "DASHBOARD_CARDS_KM_OUTSIDE_HOURS",
        "Tiempo de uso": "DASHBOARD_CARDS_ENGINE_TIME",
        "Tiempo de inactividad": "DASHBOARD_CARDS_IDLE_TIME",
        "Tiempo apagado": "DASHBOARD_CARDS_OFF_TIME",
        "Km por encima del límite de velocidad de la vía": "DASHBOARD_CARDS_SPEED_LIMIT_DISTANCE",
        "Km por encima del límite de velocidad de la empresa": "DASHBOARD_CARDS_COMPANY_SPEED_LIMIT_DISTANCE",
    };

    const getTooltipKey = (label) => {
        return labelToTooltip[label] || "";
    };

    return (
        <div className="kpi-grid" ref={cardRef}>
            {isLoading ? (
                Array.from({ length: 10 }, (_, index) => (
                    <div key={`loading-${index}`} className="kpi-card kpi-card-loading">
                        <div className="kpi-icon-loading">
                            <ImSpinner2 className="spinner" />
                        </div>
                        <div className="kpi-description">
                            <div className="kpi-label-loading"></div>
                            <div className="kpi-value-loading"></div>
                        </div>
                    </div>
                ))
            ) : (
                <>
                    {data.map((kpi, index) => (
                        <div key={index} className="kpi-card">
                            {/* ✅ NOVO: Ícone de tooltip no canto superior direito */}
                            <kpi.icon className="kpi-icon" />
                            <div className="kpi-description">
                                <div className="kpi-label">
                                    {kpi.label}
                                </div>
                                <div className="kpi-value">{kpi.value}</div>
                            </div>
                            <div className="kpi-card-tooltip">
                                {getTooltipKey(kpi.label) && (
                                    <TooltipIcon
                                        tooltipKey={getTooltipKey(kpi.label)}
                                        placement="bottom"
                                    />
                                )}
                            </div>
                        </div>
                    ))}

                    {placeholders.map((_, i) => (
                        <div key={`p-${i}`} className="kpi-card"></div>
                    ))}
                </>
            )}
        </div>
    )
}
